"use client";

import { create } from "zustand";

type PendingFileState = {
  /** File waiting to be added to a new song */
  pendingFile: File | null;
  /** Store a file to be picked up after navigation */
  setPendingFile: (file: File | null) => void;
  /** Consume and clear the pending file */
  consumePendingFile: () => File | null;
};

export const usePendingFileStore = create<PendingFileState>((set, get) => ({
  pendingFile: null,
  setPendingFile: (file) => set({ pendingFile: file }),
  consumePendingFile: () => {
    const file = get().pendingFile;
    set({ pendingFile: null });
    return file;
  },
}));
